export default __webpack_public_path__ + "b35471a76176606771bd69550687512f.svg";